import type { FC, SyntheticEvent } from 'react';
import { useTransition } from 'react';

import { Box, useTheme } from '@mui/material';
import { components } from 'react-select';

import { NavigationTabs } from '@shared/ui-kit';
import { MenuListSkeleton } from '@shared/ui-kit/selects/MuiSelect/SwitcherMenuList/components/MenuListSkeleton/MenuListSkeleton';

const SwitcherMenuList: FC<any> = (props) => {
  const theme = useTheme();
  const [isPending, startTransition] = useTransition();

  const handleChangeTab = (event: SyntheticEvent, newValue: number) => {
    startTransition(() => {
      if (newValue == 0) {
        props.switcherSecondBtnClick();
      } else {
        props.switcherFirstBtnClick();
      }
      props.setTabsIndex(newValue);
    });
  };

  const tabs = [
    { ...props.tabs[0], isDisable: isPending },
    { ...props.tabs[1], isDisable: isPending },
  ];

  return (
    <components.MenuList {...props}>
      <Box
        sx={{
          position: 'relative',
          minHeight: `${props.minHeightSelectMenu}px !important`,
        }}
      >
        <Box
          sx={{
            minHeight: `${props.minHeightSelectMenu - 46}px`,
            padding: '4px',
          }}
        >
          {isPending ? <MenuListSkeleton /> : props.children}
        </Box>
        <Box sx={{ width: '100%', position: 'sticky', bottom: 0 }}>
          <NavigationTabs
            tabsScrollerCustomStyles={{
              border: 'none',
              borderTop: `0.5px solid ${theme.palette.case.neutral.n200}`,
              borderRadius: 0,
              borderBottomRightRadius: '8px',
              borderBottomLeftRadius: '8px',
            }}
            minWidthTabs="50%"
            variant="gray"
            value={props.tabsIndex}
            handleChange={handleChangeTab}
            tabs={tabs}
            scrollButtons={false}
            hideTabsLabel={false}
          />
        </Box>
      </Box>
    </components.MenuList>
  );
};

export default SwitcherMenuList;
